import { faEnvelope, faUser } from "@fortawesome/free-solid-svg-icons"
import StyledInputField from "../../../../parts/styled-field/styled-input-field"
import { IStyledFieldProps } from "../../../../parts/styled-field/styled-input-field"
import { RegisterFromEmailInput } from "../../../../../rpcs/dist/UserRPC"
import { AuthAgreementCheck, ICheckboxProps } from "../auth-agreement-check"

export const formId = "SnsConnectAuth"

export type IFormField = Pick<
  RegisterFromEmailInput,
  "screenName" | "name" | "email"
> & {
  agreementCheck: string
}

export const formData: Array<
  | IStyledFieldProps<
      keyof Pick<RegisterFromEmailInput, "screenName" | "name" | "email">
    >
  | ICheckboxProps<"agreementCheck">
> = [
  {
    name: "screenName",
    title: "名前",
    icon: faUser,
    type: "text",
    placeholder: "例: チャットキャスト",
    component: StyledInputField,
  },
  {
    name: "name",
    title: "ユーザーID",
    icon: faUser,
    type: "text",
    placeholder: "例: chatcast",
    component: StyledInputField,
  },
  {
    name: "email",
    title: "メールアドレス",
    icon: faEnvelope,
    type: "email",
    placeholder: "例: mail@chatca.st",
    component: StyledInputField,
  },
  {
    name: "agreementCheck",
    component: AuthAgreementCheck,
  },
]
